export default __webpack_public_path__ + "static/media/rightarrow.548cb921.svg";